(() => {
  const DRAWER_SELECTOR = '#Drawer-Search';
  const SEARCH_SELECTOR = `${DRAWER_SELECTOR} predictive-search`;
  const INPUT_SELECTOR = '[data-predictive-search-input]';
  const MOBILE_QUERY = '(max-width: 767.98px)';

  const isMobile = () => window.matchMedia(MOBILE_QUERY).matches;

  const revealResults = (search) => {
    if (!isMobile()) return;

    search.open?.();

    const drawer = document.querySelector(DRAWER_SELECTOR);
    const scroller = drawer?.querySelector('.f-drawer__scroller');
    const target = search.querySelector(
      '.f-predictive-search__result-products, .f-predictive-search__empty, [data-predictive-search]'
    );

    if (!scroller || !target) return;

    window.requestAnimationFrame(() => {
      const scrollerRect = scroller.getBoundingClientRect();
      const targetRect = target.getBoundingClientRect();
      const top = scroller.scrollTop + targetRect.top - scrollerRect.top - 8;
      scroller.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
    });
  };

  const commitQuery = (search, input) => {
    if (!isMobile()) return;

    const query = input.value.trim();
    if (!query) return;

    search.dataset.iosFocusCommitPending = 'true';
    search.open?.();

    const currentQuery = String(search.searchTerm || '').trim();
    const needsSearch = currentQuery !== query
      || (!search.hasAttribute('loading') && search.getAttribute('results') !== 'true');

    if (needsSearch && typeof search.onChange === 'function') {
      search.onChange();
    }

    if (!search.hasAttribute('loading') && search.getAttribute('results') === 'true') {
      delete search.dataset.iosFocusCommitPending;
      revealResults(search);
    }
  };

  const bindSearch = (search) => {
    if (search.dataset.iosFocusFixBound === 'true') return;

    const input = search.querySelector(INPUT_SELECTOR);
    if (!input) return;

    search.dataset.iosFocusFixBound = 'true';

    // iOS' Form Assistant removes focus when "Fertig" is tapped. The theme's
    // regular focusout handler would otherwise close only the result panel.
    search.addEventListener('focusout', (event) => {
      if (!isMobile() || event.target !== input) return;

      event.stopImmediatePropagation();
      window.setTimeout(() => commitQuery(search, input), 0);
    }, true);

    input.addEventListener('blur', () => {
      if (!isMobile()) return;
      window.setTimeout(() => commitQuery(search, input), 0);
    }, true);

    input.addEventListener('search', () => {
      commitQuery(search, input);
    }, true);

    const observer = new MutationObserver(() => {
      if (
        search.dataset.iosFocusCommitPending === 'true'
        && !search.hasAttribute('loading')
        && search.getAttribute('results') === 'true'
      ) {
        delete search.dataset.iosFocusCommitPending;
        revealResults(search);
      }
    });

    observer.observe(search, {
      attributes: true,
      attributeFilter: ['loading', 'results', 'open']
    });
  };

  const bindAll = async () => {
    await customElements.whenDefined('predictive-search');
    document.querySelectorAll(SEARCH_SELECTOR).forEach(bindSearch);

    const drawer = document.querySelector(DRAWER_SELECTOR);
    if (!drawer || drawer.dataset.iosFocusObserverBound === 'true') return;

    drawer.dataset.iosFocusObserverBound = 'true';
    const observer = new MutationObserver(() => {
      drawer.querySelectorAll('predictive-search').forEach(bindSearch);
    });
    observer.observe(drawer, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindAll, { once: true });
  } else {
    bindAll();
  }
})();
